var React = require('react');

function Amazonhomemenu (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#E5E5E5","fillOpacity":".15","key":0}),React.createElement("path",{"fill":"#E5E5E5","d":"M6 7H18V9H6zM6 11H18V13H6zM6 15H18V17H6z","key":1})]);
}

Amazonhomemenu.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Amazonhomemenu;

Amazonhomemenu.default = Amazonhomemenu;
